import { render, staticRenderFns } from "./modal_photo.vue?vue&type=template&id=4d0551f8&"
import script from "./modal_photo.vue?vue&type=script&lang=js&"
export * from "./modal_photo.vue?vue&type=script&lang=js&"
import style0 from "./modal_photo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports